import type {
  CatalogItemDetails,
  CreateCatalogItemFromProjectItemRequest,
  CreateCatalogItemFromProjectItemResponse,
  CreateCatalogItemRequest,
  ListCatalogItemsQuery,
  ListCatalogItemsResponse,
  UpdateBomOfferNameRequest,
  UpdateBomOfferNameResponse,
  UpdateCatalogItemRequest,
} from '@kreart/shared';
import { api } from '@/lib/api';

export function serialiseListQuery(query: ListCatalogItemsQuery): string {
  const p = new URLSearchParams();
  if (query.page !== 1) p.set('page', String(query.page));
  if (query.pageSize !== 25) p.set('pageSize', String(query.pageSize));
  if (query.search) p.set('search', query.search);
  if (query.type) p.set('type', query.type);
  if (query.includeDeleted) p.set('includeDeleted', 'true');
  const qs = p.toString();
  return qs ? `?${qs}` : '';
}

export const catalogApi = {
  list: (query: ListCatalogItemsQuery) =>
    api.get<ListCatalogItemsResponse>(`/catalog-items${serialiseListQuery(query)}`),
  get: (id: string) => api.get<CatalogItemDetails>(`/catalog-items/${id}`),
  create: (body: CreateCatalogItemRequest) => api.post<CatalogItemDetails>('/catalog-items', body),
  update: (id: string, body: UpdateCatalogItemRequest) =>
    api.patch<CatalogItemDetails>(`/catalog-items/${id}`, body),
  remove: (id: string) => api.delete<void>(`/catalog-items/${id}`),
  promoteFromProjectItem: (body: CreateCatalogItemFromProjectItemRequest) =>
    api.post<CreateCatalogItemFromProjectItemResponse>('/catalog-items/from-project-item', body),
  updateOfferName: (body: UpdateBomOfferNameRequest) =>
    api.patch<UpdateBomOfferNameResponse>('/catalog-items/offer-name', body),
};
